import React from 'react';
import { Table, Tag } from 'antd';
import { trim80Characters } from 'src/utils/utils';
import { PopoverActionMenu, MenuAction } from 'src/components/PopoverActionMenu';
import moment from 'moment';

import { useTranslation } from 'react-i18next';
import { textFrom } from 'src/utils/textFrom';

export const OutfitCollectionTable = ({
  loading,
  className,
  tableData,
  onEdit,
  onChangeAvailabilityStatus,
  onDelete,
  pagination,
  onTableChange,
  isEditModeOn,
  selectedCollectionKeys,
  setSelectedCollectionKeys
}) => {
  const { t } = useTranslation();
  const text = textFrom('components.outfitCollectionTable', t);

  const onSelectedCollectionKeysChange = (newSelectedCollectionKeys) => {
    setSelectedCollectionKeys(newSelectedCollectionKeys);
  };

  const rowSelection = {
    selectedRowKeys: selectedCollectionKeys,
    onChange: onSelectedCollectionKeysChange
  };

  const columns = [
    {
      title: text('image'),
      key: 'image',
      dataIndex: 'image',
      render: (_, record) => (
        <div className='staticImage'>
          {record?.bannerDesktop?.imageURL &&
            <img
              className='w-8 h-8 object-cover object-center'
              src={record?.bannerDesktop?.imageURL}
            />}
        </div>
      )
    },
    {
      title: text('name'),
      key: 'name',
      dataIndex: 'name',
      render: name => name
    },
    {
      title: text('id'),
      key: 'id',
      dataIndex: 'externalId',
      render: externalId => externalId
    },
    {
      title: text('description'),
      key: 'description',
      dataIndex: 'description',
      render: description => trim80Characters(description)
    },
    {
      title: text('priority'),
      key: 'priority',
      dataIndex: 'priority',
      render: priority => priority
    },
    {
      title: text('startDate'),
      key: 'startDate',
      dataIndex: 'startDate',
      render: startDate => moment(startDate).utc().format('DD MMM YYYY')
    },
    {
      title: text('endDate'),
      key: 'endDate',
      dataIndex: 'endDate',
      width: '10%',
      render: endDate => moment(endDate).utc().format('DD MMM YYYY')
    },
    {
      title: text('status'),
      key: 'status',
      dataIndex: 'published',
      render: (published) => <div><Tag>{published ? text('published') : text('draft')}</Tag></div>
    }
  ];

  const columnsWithActionMenu = [
    ...columns,
    {
      align: 'center',
      render: (_, record) => {
        const actions = (
          <PopoverActionMenu>
            <MenuAction onClick={onEdit.bind(_, record)} label={text('edit')} />
            <MenuAction onClick={onChangeAvailabilityStatus.bind(_, record)} label={record?.published ? text('unpublish') : text('publish')} />
            <MenuAction onClick={onDelete.bind(_, record)} label={text('delete')} />
          </PopoverActionMenu>
        );
        return record.editable ? actions : null;
      }
    }
  ];

  return (
    <Table
      rowKey='id'
      loading={loading}
      columns={isEditModeOn ? columns : columnsWithActionMenu}
      className={className}
      dataSource={tableData}
      onChange={onTableChange}
      pagination={{ ...pagination, showSizeChanger: false }}
      rowSelection={isEditModeOn ? rowSelection : undefined}
    />
  );
};
